import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Plan from './Plan'

const StyledPlanList = styled.div`
  border-radius: 8px;
  border: 1px solid rgba(10, 22, 70, 0.02);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: auto auto 88px;
  width: calc(100vw - 40px);
  z-index: 1;

  ${({ theme }) => theme.media.desktop} {
    box-shadow: 0 1px 1px 0 rgba(10, 22, 70, 0.1),
      0 0 1px 0 rgba(10, 22, 70, 0.06);
    flex-wrap: nowrap;
    max-width: 1240px;
    width: auto;
  }
`

const PlanList = ({ plans, recommended }) => (
  <StyledPlanList>
    {plans.map(plan => (
      <Plan key={plan.id} data={plan} recommended={recommended} />
    ))}
  </StyledPlanList>
)

PlanList.propTypes = {
  plans: PropTypes.array.isRequired,
}

export default PlanList
